module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    attrs: {
      "width": "500",
      "height": "300"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.circleSize),
      expression: "circleSize"
    }],
    attrs: {
      "type": "range",
      "min": "1",
      "max": "100",
      "step": "1"
    },
    domProps: {
      "value": _vm._s(_vm.circleSize)
    },
    on: {
      "input": function($event) {
        _vm.circleSize = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4dc993ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/d3-components/size-controller.vue
// module id = 127
// module chunks = 1